// =============================================================
// ERM AI Sleep Formula — assets/erm-sleep-formula.js
// English Royal Mattress — Complete Engine, All 14 Steps
// Vanilla JS. No dependencies. No build step.
// =============================================================
(function () {
  'use strict';

  // ── BASE SCORES ─────────────────────────────────────────────
  var ERM_BASE_SCORES = {
    core_units: 5200, surface_units: 1000, intermediate_units: 1000,
    wool_units: 1500, cashmere_units: 300, climate_units: 300
  };
  var ERM_DIMENSIONS = [
    'core_units','surface_units','intermediate_units',
    'wool_units','cashmere_units','climate_units'
  ];
  var ERM_TEMPERATURE_OPTION_KEYS = {
    'I sleep cold':'COLD','I sleep neutral':'NEUTRAL',
    'I sleep warm':'WARM','I sleep very warm':'VERY_WARM'
  };

  // ── SCORING CONFIG ──────────────────────────────────────────
  var ERM_SCORING_CONFIG = {
    WEIGHT: { brackets: [
      { limit:55,  inclusive:false, reason:'Weight under 55kg',  deltas:{ core_units:-500, intermediate_units:-100 } },
      { limit:70,  inclusive:true,  reason:'Weight 55-70kg',     deltas:{} },
      { limit:85,  inclusive:true,  reason:'Weight 71-85kg',     deltas:{ core_units:600,  surface_units:50,  intermediate_units:100, wool_units:100 } },
      { limit:100, inclusive:true,  reason:'Weight 86-100kg',    deltas:{ core_units:1300, surface_units:100, intermediate_units:200, wool_units:150 } },
      { limit:115, inclusive:true,  reason:'Weight 101-115kg',   deltas:{ core_units:2100, surface_units:150, intermediate_units:350, wool_units:200 } },
      { limit:130, inclusive:true,  reason:'Weight 116-130kg',   deltas:{ core_units:2900, surface_units:200, intermediate_units:500, wool_units:250 } },
      { limit:null,inclusive:true,  reason:'Weight over 130kg',  deltas:{ core_units:3600, surface_units:250, intermediate_units:650, wool_units:300 } }
    ]},
    SLEEP_POSITION: {
      'Side sleeper':    { reason:'Side sleeper',        deltas:{ core_units:300, surface_units:400, intermediate_units:100, wool_units:300, cashmere_units:150 } },
      'Back sleeper':    { reason:'Back sleeper',        deltas:{ core_units:400, intermediate_units:100, wool_units:100 } },
      'Stomach sleeper': { reason:'Stomach sleeper',     deltas:{ core_units:600, surface_units:-100, intermediate_units:150 } },
      'Combination':     { reason:'Combination sleeper', deltas:{ core_units:500, surface_units:150, intermediate_units:150, wool_units:150, cashmere_units:50 } }
    },
    FIRMNESS: {
      'Soft':        { reason:'Prefers soft',        deltas:{ core_units:-200, surface_units:600, intermediate_units:100, wool_units:400, cashmere_units:250 } },
      'Medium':      { reason:'Prefers medium',      deltas:{ surface_units:200, intermediate_units:100, wool_units:200, cashmere_units:100 } },
      'Medium firm': { reason:'Prefers medium firm', deltas:{ core_units:400, intermediate_units:150, wool_units:100 } },
      'Firm':        { reason:'Prefers firm',        deltas:{ core_units:800, surface_units:-200, intermediate_units:200, cashmere_units:-50 } },
      'Not sure':    { reason:'Firmness not stated', deltas:{} }
    },
    PRESSURE: {
      'Rarely':     { reason:'Rare pressure points',     deltas:{} },
      'Never':      { reason:'No pressure points',       deltas:{} },
      'Sometimes':  { reason:'Mild pressure points',     deltas:{ surface_units:250, wool_units:150, cashmere_units:100 } },
      'Yes, often': { reason:'Moderate pressure points', deltas:{ surface_units:500, intermediate_units:150, wool_units:300, cashmere_units:200 } }
    },
    NIGHT_MOVEMENT: {
      'Rarely':     { reason:'Rarely tosses',     deltas:{} },
      'Sometimes':  { reason:'Sometimes tosses',  deltas:{ core_units:200 } },
      'Often':      { reason:'Often tosses',      deltas:{ core_units:500, surface_units:100, intermediate_units:150 } },
      'Very often': { reason:'Very often tosses', deltas:{ core_units:800, surface_units:100, intermediate_units:300 } }
    },
    TEMPERATURE: {
      'COLD':      { reason:'Sleeps cold',      deltas:{ surface_units:100, wool_units:350, cashmere_units:50, climate_units:-100 } },
      'NEUTRAL':   { reason:'Sleeps neutral',   deltas:{} },
      'WARM':      { reason:'Sleeps warm',      deltas:{ surface_units:100, climate_units:300 } },
      'VERY_WARM': { reason:'Sleeps very warm', deltas:{ surface_units:100, wool_units:-100, climate_units:550 } }
    },
    AGE: {
      'Under 30': { reason:'Age under 30', deltas:{} },
      '30-45':    { reason:'Age 30-45',    deltas:{ surface_units:100 } },
      '46-60':    { reason:'Age 46-60',    deltas:{ surface_units:200, intermediate_units:100, wool_units:100, cashmere_units:50 } },
      '61-70':    { reason:'Age 61-70',    deltas:{ surface_units:350, intermediate_units:150, wool_units:150, cashmere_units:100 } },
      'Over 70':  { reason:'Age over 70',  deltas:{ surface_units:500, intermediate_units:250, wool_units:200, cashmere_units:150 } }
    },
    PARTNER_WEIGHT_DIFF: {
      'Under 10 kg': { reason:'Partner diff <10kg',   deltas:{} },
      '10-20 kg':    { reason:'Partner diff 10-20kg', deltas:{ core_units:200 } },
      '20-30 kg':    { reason:'Partner diff 20-30kg', deltas:{ core_units:500 } },
      '30-40 kg':    { reason:'Partner diff 30-40kg', deltas:{ core_units:800 } },
      '40-50 kg':    { reason:'Partner diff 40-50kg', deltas:{ core_units:1100 } },
      '50-60 kg':    { reason:'Partner diff 50-60kg', deltas:{ core_units:1400 } },
      'Over 60 kg':  { reason:'Partner diff >60kg',   deltas:{ core_units:1700 } }
    },
    PARTNER_FIRMNESS_DIFF: {
      'Similar preferences':   { reason:'Partner firmness similar', deltas:{} },
      'Different preferences': { reason:'Partner firmness differs', deltas:{ surface_units:300, intermediate_units:250 } }
    },
    COMFORT_AMBITION: {
      'Essential quality':       { reason:'Essential quality',   deltas:{} },
      'Comfort & value':         { reason:'Comfort and value',   deltas:{ surface_units:200, wool_units:200, cashmere_units:100 } },
      'High-end comfort':        { reason:'High-end comfort',    deltas:{ surface_units:500, wool_units:400, cashmere_units:300, climate_units:200 } },
      'The best ERM experience': { reason:'Best ERM experience', deltas:{ surface_units:800, wool_units:600, cashmere_units:500, climate_units:400 } }
    },
    MATTRESS_COMPLAINT: {
      'Too soft':          { reason:'Complaint: too soft',          deltas:{ core_units:500, surface_units:-200 } },
      'Too firm':          { reason:'Complaint: too firm',          deltas:{ surface_units:500, wool_units:250, cashmere_units:150 } },
      'Sleeps too hot':    { reason:'Complaint: sleeps too hot',    deltas:{ climate_units:450 } },
      'Partner movement':  { reason:'Complaint: partner movement',  deltas:{ core_units:300, intermediate_units:250 } },
      'Shoulder pressure': { reason:'Complaint: shoulder pressure', deltas:{ surface_units:500 } },
      'Hip pressure':      { reason:'Complaint: hip pressure',      deltas:{ surface_units:500 } },
      'Poor support':      { reason:'Complaint: poor support',      deltas:{ core_units:600 } },
      'No complaints':     { reason:'Complaint: none',              deltas:{} },
      'Other':             { reason:'Complaint: other',             deltas:{} }
    }
  };

  // ── SCORING ENGINE ──────────────────────────────────────────
  function resolveWeightBracket(kg) {
    var b = ERM_SCORING_CONFIG.WEIGHT.brackets;
    for (var i = 0; i < b.length; i++) {
      if (b[i].limit === null) return b[i];
      if (b[i].inclusive ? kg <= b[i].limit : kg < b[i].limit) return b[i];
    }
    return b[b.length - 1];
  }

  function calculateErmScore(profile) {
    var scores = {};
    ERM_DIMENSIONS.forEach(function (d) { scores[d] = ERM_BASE_SCORES[d]; });
    var adjustments = [];
    function applyEntry(rule, entry) {
      if (!entry) return;
      ERM_DIMENSIONS.forEach(function (dim) {
        var delta = (entry.deltas && entry.deltas[dim]) ? entry.deltas[dim] : 0;
        if (rule === 'COMFORT_AMBITION' && dim === 'core_units') delta = 0;
        if (!delta) return;
        scores[dim] += delta;
        adjustments.push({ rule: rule, dimension: dim, delta: delta, reason: entry.reason });
      });
    }
    applyEntry('WEIGHT', resolveWeightBracket(parseFloat(profile.weight_kg) || 0));
    applyEntry('AGE',             ERM_SCORING_CONFIG.AGE[profile.age]);
    applyEntry('SLEEP_POSITION',  ERM_SCORING_CONFIG.SLEEP_POSITION[profile.sleep_position]);
    applyEntry('FIRMNESS',        ERM_SCORING_CONFIG.FIRMNESS[profile.firmness_preference]);
    applyEntry('PRESSURE',        ERM_SCORING_CONFIG.PRESSURE[profile.pressure_points]);
    applyEntry('NIGHT_MOVEMENT',  ERM_SCORING_CONFIG.NIGHT_MOVEMENT[profile.tossing]);
    applyEntry('TEMPERATURE',     ERM_SCORING_CONFIG.TEMPERATURE[ERM_TEMPERATURE_OPTION_KEYS[profile.temperature_type] || '']);
    if (profile.partner === 'Yes') {
      applyEntry('PARTNER_WEIGHT_DIFF',   ERM_SCORING_CONFIG.PARTNER_WEIGHT_DIFF[profile.partner_weight_diff]);
      applyEntry('PARTNER_FIRMNESS_DIFF', ERM_SCORING_CONFIG.PARTNER_FIRMNESS_DIFF[profile.partner_firmness_diff]);
    }
    applyEntry('COMFORT_AMBITION', ERM_SCORING_CONFIG.COMFORT_AMBITION[profile.comfort_ambition]);
    (Array.isArray(profile.mattress_complaint) ? profile.mattress_complaint : []).forEach(function (comp) {
      applyEntry('MATTRESS_COMPLAINT', ERM_SCORING_CONFIG.MATTRESS_COMPLAINT[comp]);
    });
    ERM_DIMENSIONS.forEach(function (d) { if (scores[d] < 0) scores[d] = 0; });
    return { scores: scores, adjustments: adjustments };
  }

  // ── RECOMMENDATION CONFIG ───────────────────────────────────
  var ERM_RECOMMENDATION_CONFIG = {
    CORE_THRESHOLDS: { ERM_5500_MAX: 6600, ERM_9000_MAX: 9799 },
    SURFACE_THRESHOLDS: { OPTIONAL_MIN: 1400, RECOMMENDED_ALTERNATIVE_MIN: 2100, STRONG_MIN: 2800 },
    PRIORITY_LEVELS: ['LOW','OPTIONAL','RECOMMENDED_ALTERNATIVE','STRONG'],
    GUARDRAIL_CORE_MIN: 9800,
    TOP_PILLOW_COMBINATIONS: { ERM_5500: 'ERM_5500_TOP_PILLOW', ERM_9000: 'ERM_9000_TOP_PILLOW' },
    COMFORT_ALTERNATIVE_MIN_PRIORITY: { ERM_5500: 'RECOMMENDED_ALTERNATIVE', ERM_9000: 'STRONG' },
    PREMIUM_LADDER: { ERM_5500: 'ERM_9000', ERM_9000: 'ERM_12500', ERM_12500: null },
    BOOST_TRIGGERS: {
      SIDE_SLEEPER: ['Side sleeper'],
      SOFT_MEDIUM:  ['Soft','Medium'],
      PRESSURE:     ['Yes, often'],
      AMBITION:     ['High-end comfort','The best ERM experience']
    },
    REDUCE_TRIGGERS: { FIRM: ['Firm'] },
    DISPLAY_NAMES: {
      ERM_5500: 'ERM 5500', ERM_9000: 'ERM 9000', ERM_12500: 'ERM 12500',
      ERM_5500_TOP_PILLOW: 'ERM 5500 + ERM Top Pillow',
      ERM_9000_TOP_PILLOW: 'ERM 9000 + ERM Top Pillow'
    }
  };

  // ── RECOMMENDATION ENGINE ───────────────────────────────────
  function formatConfigurationName(code) {
    if (!code) return 'None';
    return ERM_RECOMMENDATION_CONFIG.DISPLAY_NAMES[code] || code.split('_').join(' ');
  }

  function resolveRecommendationFromScores(scores, profile) {
    var cfg = ERM_RECOMMENDATION_CONFIG;
    var levels = cfg.PRIORITY_LEVELS;
    var rc = [];
    var primary;
    if (scores.core_units <= cfg.CORE_THRESHOLDS.ERM_5500_MAX) {
      primary = 'ERM_5500'; rc.push('CORE_ERM_5500');
    } else if (scores.core_units <= cfg.CORE_THRESHOLDS.ERM_9000_MAX) {
      primary = 'ERM_9000'; rc.push('CORE_ERM_9000');
    } else {
      primary = 'ERM_12500'; rc.push('CORE_ERM_12500');
    }
    var st = cfg.SURFACE_THRESHOLDS;
    var pi;
    if      (scores.surface_units >= st.STRONG_MIN)                  { pi = 3; rc.push('SURFACE_STRONG'); }
    else if (scores.surface_units >= st.RECOMMENDED_ALTERNATIVE_MIN) { pi = 2; rc.push('SURFACE_RECOMMENDED'); }
    else if (scores.surface_units >= st.OPTIONAL_MIN)                { pi = 1; rc.push('SURFACE_OPTIONAL'); }
    else                                                              { pi = 0; rc.push('SURFACE_LOW'); }
    var boost = false;
    if (cfg.BOOST_TRIGGERS.SIDE_SLEEPER.indexOf(profile.sleep_position     || '') !== -1) { boost = true; rc.push('SIDE_SLEEPER_BOOST'); }
    if (cfg.BOOST_TRIGGERS.SOFT_MEDIUM.indexOf(profile.firmness_preference  || '') !== -1) { boost = true; rc.push('SOFT_MEDIUM_BOOST'); }
    if (cfg.BOOST_TRIGGERS.PRESSURE.indexOf(profile.pressure_points         || '') !== -1) { boost = true; rc.push('PRESSURE_BOOST'); }
    if (cfg.BOOST_TRIGGERS.AMBITION.indexOf(profile.comfort_ambition        || '') !== -1) { boost = true; rc.push('AMBITION_BOOST'); }
    if (boost) pi = Math.min(levels.length - 1, pi + 1);
    if (cfg.REDUCE_TRIGGERS.FIRM.indexOf(profile.firmness_preference || '') !== -1) {
      rc.push('FIRM_REDUCE');
      pi = Math.max(0, pi - 1);
    }
    var tpp = levels[pi];
    var ca = null;
    if (scores.core_units >= cfg.GUARDRAIL_CORE_MIN || primary === 'ERM_12500') {
      rc.push('GUARDRAIL_12500_APPLIED');
    } else {
      var minP = cfg.COMFORT_ALTERNATIVE_MIN_PRIORITY[primary] || 'STRONG';
      if (pi >= levels.indexOf(minP)) ca = cfg.TOP_PILLOW_COMBINATIONS[primary] || null;
    }
    var po = (cfg.PREMIUM_LADDER[primary] !== undefined) ? cfg.PREMIUM_LADDER[primary] : null;
    return { primary: primary, comfort_alternative: ca, premium_option: po,
             top_pillow_priority: tpp, top_pillow_as_comfort_arch: ca !== null, reason_codes: rc };
  }

  function resolveRecommendation(profile) {
    return resolveRecommendationFromScores(calculateErmScore(profile).scores, profile);
  }

  // ── PROFILE LABELS ──────────────────────────────────────────
  var ERM_PROFILE_LABEL_CONFIG = {
    SUPPORT: { balanced_max:6600, enhanced_max:9799,
               labels:{ balanced:'Balanced', enhanced:'Enhanced', advanced:'Advanced' } },
    COMFORT: { supportive_max:1999, balanced_max:2799, medium_plush_max:3499,
               labels:{ supportive:'Supportive', balanced:'Balanced', medium_plush:'Medium-Plush', plush:'Plush' } },
    CLIMATE: { neutral_max:399, enhanced_max:699,
               labels:{ neutral:'Neutral', enhanced:'Enhanced Breathability', high:'High Climate Balance' } },
    SURFACE: { low_max:1399, moderate_max:2099, high_max:2799,
               labels:{ low:'Low', moderate:'Moderate', high:'High', very_high:'Very High' } },
    PARTNER: { dual_zone:['Over 60 kg','50-60 kg','40-50 kg','30-40 kg'], balanced_dual:['20-30 kg','10-20 kg'],
               labels:{ dual_zone:'Dual-Zone Stability', balanced_dual:'Balanced Dual Support', shared:'Shared Comfort' } }
  };

  function resolveProfileLabels(scores, profile) {
    var sc = ERM_PROFILE_LABEL_CONFIG.SUPPORT;
    var cc = ERM_PROFILE_LABEL_CONFIG.COMFORT;
    var cl = ERM_PROFILE_LABEL_CONFIG.CLIMATE;
    var su = ERM_PROFILE_LABEL_CONFIG.SURFACE;
    var pa = ERM_PROFILE_LABEL_CONFIG.PARTNER;
    var support = scores.core_units <= sc.balanced_max ? sc.labels.balanced
                : scores.core_units <= sc.enhanced_max ? sc.labels.enhanced : sc.labels.advanced;
    var fill = scores.wool_units + scores.cashmere_units;
    var comfort = fill <= cc.supportive_max   ? cc.labels.supportive
                : fill <= cc.balanced_max     ? cc.labels.balanced
                : fill <= cc.medium_plush_max ? cc.labels.medium_plush : cc.labels.plush;
    var climate = scores.climate_units <= cl.neutral_max  ? cl.labels.neutral
                : scores.climate_units <= cl.enhanced_max ? cl.labels.enhanced : cl.labels.high;
    var surface = scores.surface_units <= su.low_max      ? su.labels.low
                : scores.surface_units <= su.moderate_max ? su.labels.moderate
                : scores.surface_units <= su.high_max     ? su.labels.high : su.labels.very_high;
    var partner = null;
    if (profile.partner === 'Yes') {
      var wd = profile.partner_weight_diff || '';
      partner = pa.dual_zone.indexOf(wd) !== -1    ? pa.labels.dual_zone
              : pa.balanced_dual.indexOf(wd) !== -1 ? pa.labels.balanced_dual : pa.labels.shared;
    }
    return { support_profile: support, comfort_profile: comfort,
             climate_profile: climate, surface_profile: surface, partner_profile: partner };
  }

  // ── MATCH ENGINE ────────────────────────────────────────────
  var ERM_MATCH_CONFIG = {
    WEIGHTS: { core_match:0.40, surface_match:0.20, intermediate_match:0.15,
               natural_fill_match:0.10, sleep_firmness_match:0.10, climate_match:0.05 },
    PRODUCTS: {
      ERM_5500:  { core_ref:5500,  surface_ref:1200, intermediate_ref:1100, natural_fill_ref:1800, climate_ref:350 },
      ERM_9000:  { core_ref:9000,  surface_ref:2000, intermediate_ref:1500, natural_fill_ref:2500, climate_ref:450 },
      ERM_12500: { core_ref:12500, surface_ref:2800, intermediate_ref:2000, natural_fill_ref:3200, climate_ref:600 }
    },
    PRIMARY_BONUS: 5, MIN_MATCH: 60, MAX_MATCH: 99,
    INVALID_COMBINATION_CAP: { core_min:9800, product:'ERM_5500', max_match:72 },
    BASE_PRODUCT_OF: { ERM_5500_TOP_PILLOW:'ERM_5500', ERM_9000_TOP_PILLOW:'ERM_9000' }
  };

  function proximityScore(a, b) {
    var l = Math.max(a, b);
    if (l <= 0) return 1;
    return Math.min(1, Math.max(0, 1 - Math.abs(a - b) / l));
  }

  function calculateMatchScore(productKey, scores, profile) {
    var p = ERM_MATCH_CONFIG.PRODUCTS[productKey];
    if (!p) return ERM_MATCH_CONFIG.MIN_MATCH;
    var w = ERM_MATCH_CONFIG.WEIGHTS;
    var rec = resolveRecommendationFromScores(scores, profile);
    var isPrimary = rec.primary === productKey;
    var fill = scores.wool_units + scores.cashmere_units;
    var weighted =
      proximityScore(scores.core_units,        p.core_ref)         * w.core_match +
      proximityScore(scores.surface_units,      p.surface_ref)      * w.surface_match +
      proximityScore(scores.intermediate_units, p.intermediate_ref) * w.intermediate_match +
      proximityScore(fill,                      p.natural_fill_ref) * w.natural_fill_match +
      (isPrimary ? 1 : 0.5)                                         * w.sleep_firmness_match +
      proximityScore(scores.climate_units,      p.climate_ref)      * w.climate_match;
    var result = weighted * 100 + (isPrimary ? ERM_MATCH_CONFIG.PRIMARY_BONUS : 0);
    var bounded = Math.min(ERM_MATCH_CONFIG.MAX_MATCH, Math.max(ERM_MATCH_CONFIG.MIN_MATCH, Math.round(result)));
    var cap = ERM_MATCH_CONFIG.INVALID_COMBINATION_CAP;
    if (scores.core_units >= cap.core_min && productKey === cap.product) bounded = Math.min(bounded, cap.max_match);
    return bounded;
  }

  function resolveBaseProductKey(key) { return ERM_MATCH_CONFIG.BASE_PRODUCT_OF[key] || key; }

  // ── REASON CODE COPY ────────────────────────────────────────
  var ERM_REASON_CODE_COPY = {
    CORE_ERM_5500:           'Your calculated support profile is closest to the ERM 5500 integrated architecture.',
    CORE_ERM_9000:           'Your core-support profile is closest to ERM 9000.',
    CORE_ERM_12500:          'Your profile indicates a requirement for the highest integrated ERM support architecture.',
    SURFACE_STRONG:          'Your comfort profile benefits from greater surface adaptation.',
    SURFACE_RECOMMENDED:     'Your comfort profile supports enhanced surface comfort.',
    SURFACE_OPTIONAL:        'Your comfort profile is compatible with additional surface comfort.',
    SURFACE_LOW:             'Your comfort profile is well-served by the integrated surface construction.',
    SIDE_SLEEPER_BOOST:      'Your sleeping position increases the importance of responsive surface comfort.',
    SOFT_MEDIUM_BOOST:       'Your firmness preference supports a more adaptive surface construction.',
    PRESSURE_BOOST:          'Your pressure sensitivity profile benefits from enhanced surface adaptation.',
    AMBITION_BOOST:          'Your stated comfort expectations favour a more refined ERM experience.',
    FIRM_REDUCE:             'Your preference places greater emphasis on integrated support and stability.',
    GUARDRAIL_12500_APPLIED: 'Your profile requires the highest integrated ERM support architecture.'
  };

  function buildRecommendationExplanation(rc) {
    var s = [];
    for (var i = 0; i < rc.length; i++) {
      var copy = ERM_REASON_CODE_COPY[rc[i]];
      if (copy && s.indexOf(copy) === -1 && s.length < 3) s.push(copy);
    }
    return s.join(' ');
  }

  // ── TOP PILLOW COPY ─────────────────────────────────────────
  var ERM_TOP_PILLOW_COPY = {
    STRONG:                  'Your recommended ERM mattress already meets your calculated structural requirements. If you prefer additional surface comfort and a deeper luxury feel, an ERM Top Pillow can be added as an optional comfort enhancement.',
    RECOMMENDED_ALTERNATIVE: 'Your recommended ERM mattress already meets your calculated structural requirements. If you prefer additional surface comfort and a deeper luxury feel, an ERM Top Pillow can be added as an optional comfort enhancement.',
    OPTIONAL:                'An ERM Top Pillow is compatible with your profile as an optional comfort layer.',
    LOW:                     'An ERM Top Pillow is available as an optional addition.'
  };

  // ── PRODUCT URL STUBS ───────────────────────────────────────
 var ERM_PRODUCT_URLS = {
  ERM_5500: 'https://englishroyalmattress.com/products/english-royal-mattress-5500-pocket',
  ERM_9000: 'https://englishroyalmattress.com/products/english-royal-mattress-9000-pocket-british-mattress',
  ERM_12500: 'https://englishroyalmattress.com/products/english-royal-mattress-12500-pocket',
  TOP_PILLOW_2000: 'https://englishroyalmattress.com/products/english-royal-mattress-4000-pocket-toppillow',
};

  // ── QUESTIONNAIRE DATA ──────────────────────────────────────
  var QUESTION_STEPS = [
    { step:2, title:'Body Profile', questions:[
      { id:'age',            label:'What is your age?',                              options:['Under 30','30-45','46-60','61-70','Over 70'] },
      { id:'body_type',      label:'How would you describe your body type?',         options:['Slim','Average','Athletic','Larger build'] },
      { id:'sleep_position', label:'What is your primary sleep position?',           options:['Side sleeper','Back sleeper','Stomach sleeper','Combination'] }
    ]},
    { step:3, title:'Sleep Profile', questions:[
      { id:'sleep_duration',        label:'How many hours of sleep do you typically get?',      options:['Less than 5h','5-6h','6-7h','7-8h','More than 8h'] },
      { id:'schedule_consistency',  label:'How consistent is your sleep schedule?',             options:['Very consistent','Fairly consistent','Irregular'] },
      { id:'time_to_fall_asleep',   label:'How long does it usually take you to fall asleep?', options:['Under 10 min','10-20 min','20-30 min','Over 30 min'] },
      { id:'night_wakings',         label:'How often do you wake during the night?',           options:['Rarely','1-2 times','3+ times','Almost every night'] }
    ]},
    { step:4, title:'Comfort Profile', questions:[
      { id:'firmness_preference',   label:'Do you have a firmness preference?',                                       options:['Soft','Medium','Medium firm','Firm','Not sure'] },
      { id:'pressure_points',       label:'Do you experience pressure points while sleeping?',                        options:['Yes, often','Sometimes','Rarely','Never'] },
      { id:'partner',               label:'Do you share your bed with a partner?',                                    options:['No','Yes'] },
      { id:'partner_weight_diff',   label:'What is the approximate weight difference between you and your partner?', options:['Under 10 kg','10-20 kg','20-30 kg','30-40 kg','40-50 kg','50-60 kg','Over 60 kg'], showWhen:function(p){return p.partner==='Yes';} },
      { id:'partner_firmness_diff', label:'Do you and your partner have different firmness preferences?',            options:['Similar preferences','Different preferences'], showWhen:function(p){return p.partner==='Yes';} },
      { id:'comfort_ambition',      label:'What kind of sleep experience are you looking for?',                      options:['Essential quality','Comfort & value','High-end comfort','The best ERM experience'] }
    ]},
    { step:5, title:'Temperature & Current Mattress', questions:[
      { id:'temperature_type',              label:'How do you sleep in terms of temperature?',          options:['I sleep cold','I sleep neutral','I sleep warm','I sleep very warm'] },
      { id:'current_mattress_type',         label:'What type of mattress do you currently sleep on?',   options:['Innerspring/coil','Memory foam','Latex','Hybrid','Futon/other',"I don't know"] },
      { id:'current_mattress_age',          label:'How old is your current mattress?',                  options:['Less than 2 years','2-5 years','5-10 years','Over 10 years'] },
      { id:'current_mattress_satisfaction', label:'How satisfied are you with your current mattress?', options:['Very satisfied','Somewhat satisfied','Neutral','Unsatisfied','Very unsatisfied'] },
      { id:'mattress_complaint', label:'What is your main complaint about your current mattress?',
        options:['Too soft','Too firm','Sleeps too hot','Partner movement','Shoulder pressure','Hip pressure','Poor support','No complaints','Other'],
        multiple:true, exclusiveOption:'No complaints' }
    ]},
    { step:6, title:'Sleep Experience', questions:[
      { id:'pain',           label:'Do you experience back, neck or shoulder pain?',   options:['No pain','Occasional mild pain','Regular pain','Chronic pain'] },
      { id:'wake_up_feeling',label:'How do you feel when you wake up?',                options:['Refreshed','Slightly stiff','Stiff and sore','Exhausted'] },
      { id:'tossing',        label:'How often do you toss and turn during the night?', options:['Rarely','Sometimes','Often','Very often'] }
    ]},
    { step:7, title:'Sleep Environment', questions:[
      { id:'bedroom_temperature',label:'What is the typical temperature of your bedroom?',                options:['Cool - below 18C','Comfortable - 18-22C','Warm - above 22C'] },
      { id:'bedding_type',       label:'What type of bedding do you use?',                               options:['Light duvet','Medium duvet','Heavy duvet','Multiple layers'] },
      { id:'allergies',          label:'Do you have any allergies or sensitivities relevant to bedding?', options:['No','Dust mite allergy','Latex sensitivity','Other'] }
    ]}
  ];

  // ── CALCULATION HELPERS ─────────────────────────────────────
  var CORE_FRACTIONS = [0.30, 0.50, 0.70, 0.88, 1.00];

  function buildFormulaMetrics(s) {
    var d = (s.core_units + s.surface_units) || 1;
    return [
      { label:'Body Load Distribution',  value:(s.core_units / 10000).toFixed(3) },
      { label:'Sleep Position Response', value:(s.surface_units / 1000).toFixed(3) },
      { label:'Pressure Adaptation',     value:((s.wool_units / 2000) * 100).toFixed(1) },
      { label:'Support layer adjustment',    value:s.intermediate_units > 1000 ? '+' + ((s.intermediate_units - 1000) / 1000).toFixed(3) : '0.000' },
      { label:'Core Stability Matrix',   value:(s.core_units / d).toFixed(3) },
      { label:'Intermediate Response',   value:(s.intermediate_units / 1000).toFixed(3) },
      { label:'Natural Fibre Balance',   value:(((s.wool_units + s.cashmere_units) / 2500) * 100).toFixed(1) },
      { label:'Thermal Regulation',      value:(s.climate_units / 400).toFixed(3) }
    ];
  }

  function buildCoreCountUp(cu) {
    return CORE_FRACTIONS.map(function (f, i) {
      return i === CORE_FRACTIONS.length - 1 ? cu : Math.round(cu * f);
    });
  }

  // ── FORMULA ID ──────────────────────────────────────────────
  function generateFormulaId() {
    return 'ERM-' + Math.random().toString(36).substring(2, 7).toUpperCase();
  }

  // ── SILENT ENGINE TESTS ─────────────────────────────────────
  function runSilentEngineTests() {
    var e = { height_cm:'', weight_kg:'' };
    var tests = [
      { name:'Test 1', scores:{ core_units:7860,  surface_units:2438, intermediate_units:0,    wool_units:0,    cashmere_units:0,   climate_units:0   }, profile:Object.assign({},e,{sleep_position:'Side sleeper',firmness_preference:'Medium'}),                              exp:{ p:'ERM_9000',  ca:'ERM_9000_TOP_PILLOW', po:'ERM_12500' } },
      { name:'Test 2', scores:{ core_units:7800,  surface_units:1100, intermediate_units:0,    wool_units:0,    cashmere_units:0,   climate_units:0   }, profile:Object.assign({},e,{sleep_position:'Back sleeper', firmness_preference:'Firm'}),                               exp:{ p:'ERM_9000',  ca:null,                  po:'ERM_12500' } },
      { name:'Test 3', scores:{ core_units:10400, surface_units:0,    intermediate_units:0,    wool_units:0,    cashmere_units:0,   climate_units:0   }, profile:Object.assign({},e),                                                                                           exp:{ p:'ERM_12500', ca:null,                  po:null,          g:true } },
      { name:'Test A', scores:{ core_units:7860,  surface_units:2438, intermediate_units:1400, wool_units:2350, cashmere_units:450, climate_units:600 }, profile:Object.assign({},e,{sleep_position:'Side sleeper',firmness_preference:'Medium',comfort_ambition:'High-end comfort'}), exp:{ p:'ERM_9000', ca:'ERM_9000_TOP_PILLOW', po:'ERM_12500' } },
      { name:'Test B', scores:{ core_units:7800,  surface_units:1100, intermediate_units:1200, wool_units:1800, cashmere_units:300, climate_units:400 }, profile:Object.assign({},e,{sleep_position:'Back sleeper', firmness_preference:'Firm'}),                               exp:{ p:'ERM_9000',  ca:null,                  po:'ERM_12500', tpp:'LOW' } },
      { name:'Test C', scores:{ core_units:10400, surface_units:1500, intermediate_units:1300, wool_units:2000, cashmere_units:350, climate_units:500 }, profile:Object.assign({},e),                                                                                           exp:{ p:'ERM_12500', ca:null,                  po:null,          g:true } }
    ];
    tests.forEach(function (t) {
      var r = resolveRecommendationFromScores(t.scores, t.profile);
      var pass = r.primary === t.exp.p && r.comfort_alternative === t.exp.ca && r.premium_option === t.exp.po &&
                 (!t.exp.tpp || r.top_pillow_priority === t.exp.tpp) &&
                 (!t.exp.g   || r.reason_codes.indexOf('GUARDRAIL_12500_APPLIED') !== -1);
      console[pass ? 'log' : 'warn']('[ERM] ' + t.name + ': ' + (pass ? 'PASS' : 'FAIL p=' + r.primary + ' ca=' + r.comfort_alternative + ' po=' + r.premium_option));
    });
  }

  // ── STATE ───────────────────────────────────────────────────
  var state = {
    step: 1, profile: { height_cm:'', weight_kg:'' },
    calcElapsedMs: 0, calcInterval: null, calcTimeout: null,
    formulaId: '', customerName: '', customerEmail: '',
    emailError: '', saved: false, saveError: ''
  };

  // ── DOM HELPERS ─────────────────────────────────────────────
  function el(tag, cls, txt) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (txt !== undefined) e.textContent = txt;
    return e;
  }
  function fmt(n) { return n.toLocaleString('en-GB'); }
  function getStepDef(n) {
    for (var i = 0; i < QUESTION_STEPS.length; i++) { if (QUESTION_STEPS[i].step === n) return QUESTION_STEPS[i]; }
    return null;
  }
  function visibleQs(sd) { return sd.questions.filter(function (q) { return !q.showWhen || q.showWhen(state.profile); }); }
  function isAnswered(q) {
    if (q.multiple) { var v = state.profile[q.id]; return Array.isArray(v) && v.length > 0; }
    return !!(state.profile[q.id]);
  }
  var MEASUREMENT_LIMITS = { height_cm: { min: 1, max: 300 }, weight_kg: { min: 1, max: 500 } };
  function isValidMeasurement(id, value) {
    var limit = MEASUREMENT_LIMITS[id];
    var number = Number(value);
    return String(value).trim() !== '' && Number.isFinite(number) && number >= limit.min && number <= limit.max;
  }
  function canAdvance() {
    var sd = getStepDef(state.step);
    if (!sd) return true;
    if (state.step === 2) {
      if (!isValidMeasurement('height_cm', state.profile.height_cm) ||
          !isValidMeasurement('weight_kg', state.profile.weight_kg)) return false;
    }
    return visibleQs(sd).every(function (q) { return isAnswered(q); });
  }

  // ── STATE MUTATIONS ─────────────────────────────────────────
  function setAnswer(id, val) { state.profile[id] = val; render(); }
  function toggleMultiAnswer(id, opt, excl) {
    var cur = Array.isArray(state.profile[id]) ? state.profile[id].slice() : [];
    if (excl && opt === excl) { state.profile[id] = cur.indexOf(opt) !== -1 ? [] : [opt]; }
    else {
      var without = cur.filter(function (v) { return v !== excl && v !== opt; });
      state.profile[id] = cur.indexOf(opt) !== -1 ? without : without.concat([opt]);
    }
    render();
  }
  function goToStep(n) {
    if (state.step === 8) stopCalcTimer();
    state.step = Math.min(14, Math.max(1, n));
    if (state.step === 8) startCalcTimer();
    if (state.step === 14 && !state.formulaId) state.formulaId = generateFormulaId();
    window.scrollTo(0, 0);
    render();
  }
  function startCalcTimer() {
    state.calcElapsedMs = 0;
    state.calcInterval = setInterval(function () { state.calcElapsedMs = Math.min(5000, state.calcElapsedMs + 100); render(); }, 100);
    state.calcTimeout  = setTimeout(function () { stopCalcTimer(); state.step = 9; render(); }, 5000);
  }
  function stopCalcTimer() {
    if (state.calcInterval) { clearInterval(state.calcInterval); state.calcInterval = null; }
    if (state.calcTimeout)  { clearTimeout(state.calcTimeout);   state.calcTimeout  = null; }
  }

  // ── DOM STRUCTURE ───────────────────────────────────────────
  var $root, $progressFill, $stepLabel, $stepContainers, $navContainer;

  function buildDOM() {
    $root = document.getElementById('erm-sleep-formula-root');
    if (!$root) return;
    var bar = el('div','erm-progress-bar');
    $progressFill = el('div','erm-progress-fill');
    bar.appendChild($progressFill);
    $root.appendChild(bar);
    $stepLabel = el('div','erm-step-label');
    $root.appendChild($stepLabel);
    $stepContainers = {};
    for (var i = 1; i <= 14; i++) {
      var div = el('div','erm-step');
      div.id = 'erm-step-' + i;
      $root.appendChild(div);
      $stepContainers[i] = div;
    }
    $navContainer = el('div','erm-inner');
    $root.appendChild($navContainer);
  }

  // ── MAIN RENDER ─────────────────────────────────────────────
  function render() {
    if (!$root) return;
    $progressFill.style.width = Math.round((state.step / 14) * 100) + '%';
    $stepLabel.textContent = (state.step > 1 && state.step < 9) ? 'Step ' + state.step + ' of 14' : '';
    for (var i = 1; i <= 14; i++) {
      if (i === state.step) { $stepContainers[i].classList.add('erm-active'); }
      else { $stepContainers[i].classList.remove('erm-active'); }
    }
    var c = $stepContainers[state.step];
    c.innerHTML = '';
    if      (state.step === 1)  { renderLanding(c); }
    else if (state.step === 8)  { renderCalculation(c); }
    else if (state.step === 9)  { renderFormula(c); }
    else if (state.step === 10) { renderRecommendation(c); }
    else if (state.step === 11) { renderAlternative(c); }
    else if (state.step === 12) { renderPremium(c); }
    else if (state.step === 13) { renderOptions(c); }
    else if (state.step === 14) { renderSave(c); }
    else { var sd = getStepDef(state.step); if (sd) renderQuestionStep(c, sd); }
    $navContainer.innerHTML = '';
    if (state.step !== 8) renderNavigation($navContainer);
  }

  // ── STEP 1: LANDING ─────────────────────────────────────────
  function renderLanding(c) {
    var hero = el('div','erm-formula-editorial');
    var visual = el('div','erm-formula-visual');
    var image = document.createElement('img');
    image.src = 'https://cdn.shopify.com/s/files/1/0800/9469/1671/files/erm-country-house-tailored-divan-v2.png?v=1792743740';
    image.alt = 'A hand-tufted white mattress and upholstered English Royal Mattress bed in a country house';
    image.width = 1672; image.height = 941; image.fetchPriority = 'high';
    visual.appendChild(image);
    var caption = el('div','erm-formula-caption');
    caption.appendChild(el('span','','ENGLISH ROYAL MATTRESS'));
    caption.appendChild(el('p','','Natural materials. A personal approach to comfort.'));
    visual.appendChild(caption); hero.appendChild(visual);
    var copy = el('div','erm-formula-copy');
    copy.appendChild(el('p','erm-eyebrow','THE ERM SLEEP FORMULA'));
    copy.appendChild(el('h1','erm-h1','Comfort begins with you.'));
    copy.appendChild(el('p','erm-formula-deck','Your habits. Your preferences. Your mattress.'));
    copy.appendChild(el('p','erm-body','Tell us how you sleep and what comfort means to you. We bring your answers together into a personal ERM mattress recommendation, ready to explore with our team.'));
    var btn = el('button','erm-btn erm-btn-primary','Discover my comfort');
    btn.addEventListener('click', function () { goToStep(2); });
    copy.appendChild(btn);
    copy.appendChild(el('p','erm-formula-meta','ABOUT 4 MINUTES · NO PURCHASE REQUIRED'));
    copy.appendChild(el('p','erm-formula-note','A thoughtful starting point. Our team helps confirm the right specification for you.'));
    hero.appendChild(copy); c.appendChild(hero);
    var pathway = el('div','erm-formula-pathway');
    [['01','Tell us about you','Your sleep position, comfort preferences and daily habits.'],['02','Explore your formula','See how support and comfort layers come together for you.'],['03','Make it personal','Review your recommendation with the ERM team.']].forEach(function(item){
      var card=el('div','erm-formula-path');card.appendChild(el('span','erm-formula-index',item[0]));var text=el('div','');text.appendChild(el('h2','',item[1]));text.appendChild(el('p','',item[2]));card.appendChild(text);pathway.appendChild(card);
    }); c.appendChild(pathway);
  }

  // ── STEPS 2-7: QUESTIONNAIRE ────────────────────────────────
  function renderQuestionStep(c, sd) {
    var inner = el('div','erm-inner');
    inner.appendChild(el('p','erm-part-label','Part ' + (sd.step - 1) + ' of 6'));
    inner.appendChild(el('h2','erm-section-heading', sd.title));
    if (sd.step === 2) {
      var row = el('div','erm-input-row');
      function makeNum(labelTxt, id, ph) {
        var g = el('div','erm-input-group');
        var lbl = el('label','', labelTxt);
        var inp = document.createElement('input');
        var limits = MEASUREMENT_LIMITS[id];
        inp.id = 'erm-' + id; lbl.htmlFor = inp.id;
        inp.className = 'erm-number-input'; inp.type = 'number';
        inp.min = String(limits.min); inp.max = String(limits.max); inp.step = 'any'; inp.placeholder = ph;
        inp.value = state.profile[id] || '';
        var error = el('div','erm-input-error');
        error.id = inp.id + '-error';
        inp.setAttribute('aria-describedby', error.id);
        inp.addEventListener('input', function () {
          state.profile[id] = this.value;
          var valid = isValidMeasurement(id, this.value);
          this.setAttribute('aria-invalid', valid ? 'false' : 'true');
          error.textContent = valid ? '' : 'Enter a number from ' + limits.min + ' to ' + limits.max + (id === 'height_cm' ? ' cm.' : ' kg.');
          $navContainer.innerHTML = '';
          renderNavigation($navContainer);
        });
        g.appendChild(lbl); g.appendChild(inp); g.appendChild(error);
        return g;
      }
      row.appendChild(makeNum('Height (cm)', 'height_cm', 'e.g. 175'));
      row.appendChild(makeNum('Weight (kg)', 'weight_kg', 'e.g. 75'));
      inner.appendChild(row);
    }
    visibleQs(sd).forEach(function (q) {
      var group = el('div','erm-question-group');
      group.appendChild(el('p','erm-question-label', q.label));
      q.options.forEach(function (opt) {
        var sel = q.multiple
          ? (Array.isArray(state.profile[q.id]) && state.profile[q.id].indexOf(opt) !== -1)
          : state.profile[q.id] === opt;
        var btn = el('button', 'erm-option-card' + (sel ? ' erm-selected' : ''), opt);
        btn.addEventListener('click', (function (o) {
          return function () {
            if (q.multiple) toggleMultiAnswer(q.id, o, q.exclusiveOption);
            else setAnswer(q.id, o);
          };
        })(opt));
        group.appendChild(btn);
      });
      inner.appendChild(group);
    });
    c.appendChild(inner);
  }

  // ── STEP 8: CALCULATION ANIMATION ───────────────────────────
  function renderCalculation(c) {
    var calc = calculateErmScore(state.profile);
    var scores = calc.scores;
    var metrics = buildFormulaMetrics(scores);
    var countUp = buildCoreCountUp(scores.core_units);
    var elapsed = state.calcElapsedMs;
    var phase = elapsed < 2000 ? 1 : elapsed < 4000 ? 2 : 3;
    var screen = el('div','erm-calc-screen');
    var headingText = phase === 1 ? 'ANALYSING YOUR ERM FORMULA' : phase === 2 ? 'CALCULATING ERM ARCHITECTURE...' : 'FORMULA COMPLETE';
    screen.appendChild(el('p','erm-calc-heading', headingText));
    var track = el('div','erm-calc-progress-track');
    var fill  = el('div','erm-calc-progress-fill');
    fill.style.width = Math.round((elapsed / 5000) * 100) + '%';
    track.appendChild(fill);
    screen.appendChild(track);
    var revealed = Math.min(metrics.length, Math.floor(elapsed / 250));
    var list = el('div','erm-metric-list');
    for (var i = 0; i < revealed; i++) {
      var mrow = el('div','erm-metric-row');
      mrow.appendChild(el('span','erm-metric-label', metrics[i].label));
      mrow.appendChild(el('span','erm-metric-value', metrics[i].value));
      list.appendChild(mrow);
    }
    screen.appendChild(list);
    if (phase >= 2) {
      var ci = Math.min(countUp.length, Math.floor((elapsed - 2000) / 400) + 1);
      if (ci > 0) {
        var disp = el('div','erm-count-up-display');
        disp.appendChild(el('div','erm-count-up-number', fmt(countUp[Math.min(ci, countUp.length) - 1])));
        disp.appendChild(el('div','erm-count-up-label', 'ERM CORE SUPPORT UNITS'));
        screen.appendChild(disp);
      }
    }
    c.appendChild(screen);
  }

  // ── STEP 9: PERSONAL ERM FORMULA ────────────────────────────
  function renderFormula(c) {
    var calc = calculateErmScore(state.profile);
    var scores = calc.scores;
    var labels = resolveProfileLabels(scores, state.profile);
    var screen = el('div','erm-formula-screen');
    screen.appendChild(el('h2','erm-section-heading','YOUR PERSONAL ERM FORMULA'));
    var cd = el('div','erm-core-display');
    cd.appendChild(el('div','erm-core-number', fmt(scores.core_units)));
    cd.appendChild(el('div','erm-core-label',  'ERM CORE SUPPORT UNITS'));
    screen.appendChild(cd);
    var sec = el('div','erm-secondary-metrics');
    [{ label:'Wool Comfort',        value:scores.wool_units },
     { label:'Cashmere Refinement', value:scores.cashmere_units },
     { label:'Climate Balance',     value:scores.climate_units },
     { label:'Intermediate Layer',  value:scores.intermediate_units },
     { label:'Surface Comfort',     value:scores.surface_units }
    ].forEach(function (item) {
      var row = el('div','erm-secondary-row');
      row.appendChild(el('span','erm-secondary-label', item.label));
      row.appendChild(el('span','erm-secondary-value', fmt(item.value) + ' Units'));
      sec.appendChild(row);
    });
    sec.appendChild(el('p','erm-proprietary-note','ERM Units are internal matching values, not physical spring counts or measured comfort. Some answers provide consultation context rather than changing the score. These results are guidance, not a medical assessment.'));
    screen.appendChild(sec);
    var pb = el('div','erm-profile-block');
    pb.appendChild(el('p','erm-profile-block-heading','YOUR SLEEP PROFILE'));
    var prows = [
      { key:'Support Profile', value:labels.support_profile },
      { key:'Comfort Profile', value:labels.comfort_profile },
      { key:'Climate Profile', value:labels.climate_profile },
      { key:'Surface Profile', value:labels.surface_profile }
    ];
    if (labels.partner_profile) prows.push({ key:'Partner Profile', value:labels.partner_profile });
    prows.forEach(function (pr) {
      var row = el('div','erm-profile-row');
      row.appendChild(el('span','erm-profile-key',   pr.key));
      row.appendChild(el('span','erm-profile-value', pr.value));
      pb.appendChild(row);
    });
    screen.appendChild(pb);
    c.appendChild(screen);
  }
  // ── STEP 10: PRIMARY RECOMMENDATION ─────────────────────────
  function renderRecommendation(c) {
    var calc = calculateErmScore(state.profile);
    var scores = calc.scores;
    var rec = resolveRecommendationFromScores(scores, state.profile);
    var matchPct = calculateMatchScore(rec.primary, scores, state.profile);
    var explanation = buildRecommendationExplanation(rec.reason_codes);

    var section = el('div','erm-result-section');
    section.appendChild(el('p','erm-note','The profile index is an internal comparison guide, not a measured comfort percentage. The primary recommendation follows ERM support rules; our team can help confirm your specification.'));
    section.appendChild(
      el('h2','erm-section-heading','YOUR RECOMMENDED MATTRESS')
    );

    var card = el('div','erm-recommendation-card');

    card.appendChild(
      el('p','erm-card-eyebrow','Primary Recommendation')
    );

    card.appendChild(
      el('h3','erm-card-name', formatConfigurationName(rec.primary))
    );

    card.appendChild(
      el('span','erm-match-badge', 'PROFILE INDEX ' + matchPct + ' / 100')
    );

    card.appendChild(
      el('p','erm-card-explanation', explanation)
    );

    if (rec.primary === 'ERM_9000') {
      card.appendChild(
        el(
          'p',
          'erm-card-reassurance',
          'ERM 5500 remains an excellent ERM construction. Your calculated profile is simply closer to the ERM 9000 architecture.'
        )
      );
    }

    if (rec.primary === 'ERM_12500') {
      card.appendChild(
        el(
          'p',
          'erm-card-reassurance',
          'An ERM Top Pillow can only be added as an additional comfort layer at this specification — it is never a substitute for the ERM 12500 core.'
        )
      );
    }

    section.appendChild(card);
    c.appendChild(section);
  }


  // ── STEP 11: COMFORT ALTERNATIVE ────────────────────────────
  function renderAlternative(c) {
    var calc = calculateErmScore(state.profile);
    var scores = calc.scores;
    var rec = resolveRecommendationFromScores(scores, state.profile);
    var altKey = rec.comfort_alternative;

    var section = el('div','erm-result-section');
    section.appendChild(el('p','erm-note','The profile index is an internal comparison guide, not a measured comfort percentage. The primary recommendation follows ERM support rules; our team can help confirm your specification.'));

    section.appendChild(
      el(
        'h2',
        'erm-section-heading',
        altKey
          ? 'ALTERNATIVE COMFORT CONFIGURATION'
          : 'COMFORT CONFIGURATION'
      )
    );

    if (altKey) {
      var baseKey = resolveBaseProductKey(altKey);
      var matchPct = calculateMatchScore(
        baseKey,
        scores,
        state.profile
      );

      var card = el('div','erm-alternative-card');

      card.appendChild(
        el('p','erm-card-eyebrow','Comfort Alternative')
      );

      card.appendChild(
        el(
          'h3',
          'erm-card-name',
          formatConfigurationName(altKey)
        )
      );

      card.appendChild(
        el(
          'span',
          'erm-match-badge',
          'PROFILE INDEX ' + matchPct + ' / 100'
        )
      );

      card.appendChild(
        el(
          'p',
          'erm-card-explanation',
          'Your technical mattress recommendation remains ' +
          formatConfigurationName(rec.primary) +
          '. However, your surface-comfort profile also supports an alternative configuration using ' +
          formatConfigurationName(altKey) +
          ' for a more layered and plush sleep experience.'
        )
      );

      card.appendChild(
        el(
          'p',
          'erm-top-pillow-note',
          ERM_TOP_PILLOW_COPY[rec.top_pillow_priority] ||
          ERM_TOP_PILLOW_COPY.LOW
        )
      );

      section.appendChild(card);

    } else {

      var neutral = el('div','erm-neutral-message');

      neutral.appendChild(
        el(
          'p',
          'erm-neutral-message-heading',
          'No comfort alternative applies to your profile'
        )
      );

      neutral.appendChild(
        el(
          'p',
          'erm-neutral-message-body',
          'Your technical mattress recommendation remains ' +
          formatConfigurationName(rec.primary) +
          ', which already matches your calculated structural requirements. ' +
          (
            ERM_TOP_PILLOW_COPY[rec.top_pillow_priority] ||
            ERM_TOP_PILLOW_COPY.LOW
          )
        )
      );

      section.appendChild(neutral);
    }

    c.appendChild(section);
  }


  // ── STEP 12: PREMIUM OPTION ──────────────────────────────────
  function renderPremium(c) {
    var calc = calculateErmScore(state.profile);
    var scores = calc.scores;
    var rec = resolveRecommendationFromScores(scores, state.profile);
    var premKey = rec.premium_option;

    var section = el('div','erm-result-section');
    section.appendChild(el('p','erm-note','The profile index is an internal comparison guide, not a measured comfort percentage. The primary recommendation follows ERM support rules; our team can help confirm your specification.'));

    section.appendChild(
      el(
        'h2',
        'erm-section-heading',
        'PREMIUM ERM EXPERIENCE'
      )
    );

    if (premKey) {

      var matchPct = calculateMatchScore(
        premKey,
        scores,
        state.profile
      );

      var card = el('div','erm-premium-card');

      card.appendChild(
        el('p','erm-card-eyebrow','Premium Option')
      );

      card.appendChild(
        el(
          'h3',
          'erm-card-name',
          formatConfigurationName(premKey)
        )
      );

      card.appendChild(
        el(
          'span',
          'erm-match-badge',
          'PROFILE INDEX ' + matchPct + ' / 100'
        )
      );

      card.appendChild(
        el(
          'p',
          'erm-card-explanation',
          'Your calculated structural requirement is already satisfied by your recommended ERM mattress. ' +
          formatConfigurationName(premKey) +
          ' becomes relevant if your priority is the highest integrated ERM specification and maximum refinement rather than simply meeting your calculated requirement.'
        )
      );

      section.appendChild(card);

    } else {

      var neutral = el('div','erm-neutral-message');

      neutral.appendChild(
        el(
          'p',
          'erm-neutral-message-heading',
          'You are already at the highest ERM specification.'
        )
      );

      neutral.appendChild(
        el(
          'p',
          'erm-neutral-message-body',
          'Your calculated profile has been matched to the most advanced integrated ERM architecture available.'
        )
      );

      section.appendChild(neutral);
    }

    c.appendChild(section);
  }


  // ── STEP 13: VIEW & SHOP OPTIONS ─────────────────────────────
  function renderOptions(c) {
    var calc = calculateErmScore(state.profile);
    var scores = calc.scores;
    var rec = resolveRecommendationFromScores(
      scores,
      state.profile
    );

    var section = el('div','erm-result-section');
    section.appendChild(el('p','erm-note','The profile index is an internal comparison guide, not a measured comfort percentage. The primary recommendation follows ERM support rules; our team can help confirm your specification.'));

    section.appendChild(
      el(
        'h2',
        'erm-section-heading',
        'VIEW MY ERM OPTIONS'
      )
    );

    var cards = [
      {
        key: rec.primary,
        role: 'Your recommended configuration'
      }
    ];

    if (rec.comfort_alternative) {
      cards.push({
        key: rec.comfort_alternative,
        role: 'Alternative comfort configuration'
      });
    }

    if (rec.premium_option) {
      cards.push({
        key: rec.premium_option,
        role: 'Premium ERM experience'
      });
    }


    // Always show complete ERM core range.
    // The recommendation remains unchanged.
    [
      'ERM_5500',
      'ERM_9000',
      'ERM_12500'
    ].forEach(function (key) {

      var exists = cards.some(function (item) {
        return resolveBaseProductKey(item.key) === key;
      });

      if (!exists) {
        cards.push({
          key: key,
          role:
            key === 'ERM_12500'
              ? 'Highest ERM specification'
              : 'Other ERM configuration'
        });
      }
    });


    var grid = el('div','erm-options-grid');

    cards.forEach(function (item) {

      var baseKey =
        resolveBaseProductKey(item.key);

      var matchPct =
        calculateMatchScore(
          baseKey,
          scores,
          state.profile
        );

      var url =
        ERM_PRODUCT_URLS[baseKey] || null;

      var card =
        el('div','erm-option-product-card');


      card.appendChild(
        el(
          'p',
          'erm-option-product-role',
          item.role
        )
      );


      card.appendChild(
        el(
          'p',
          'erm-option-product-name',
          formatConfigurationName(item.key)
        )
      );


      card.appendChild(
        el(
          'span',
          'erm-match-badge',
          'PROFILE INDEX ' + matchPct + ' / 100'
        )
      );


      if (url) {

        var link =
          document.createElement('a');

        link.className =
          'erm-option-product-link';

        link.textContent =
          'VIEW MATTRESS';

        link.href =
          url;

        card.appendChild(link);

      } else {

        var unavailable =
          document.createElement('span');

        unavailable.className =
          'erm-option-product-link erm-link-disabled';

        unavailable.textContent =
          'PRODUCT UNAVAILABLE';

        card.appendChild(unavailable);
      }


      grid.appendChild(card);
    });


    section.appendChild(grid);
    c.appendChild(section);
  }


  // ── STEP 14 LEGACY FALLBACK ──────────────────────────────────
  // Email/save functionality has been removed.
  // If an old session somehow reaches step 14,
  // simply show the shopping options again.
  function renderSave(c) {
    renderOptions(c);
  }


  // ── NAVIGATION ───────────────────────────────────────────────
  function renderNavigation(container) {

    // Step 1 = landing
    // Step 13 = final shopping screen
    // Step 14 = legacy fallback
    if (
      state.step === 1 ||
      state.step === 13 ||
      state.step === 14
    ) {
      return;
    }


    var nav =
      el('div','erm-nav');

    var left =
      el('div','erm-nav-left');


    var backBtn =
      el(
        'button',
        'erm-btn erm-btn-secondary',
        'Back'
      );


    backBtn.addEventListener(
      'click',
      function () {

        goToStep(
          state.step === 10
            ? 9
            : state.step - 1
        );
      }
    );


    left.appendChild(backBtn);


    if (state.step === 10) {

      var altBtn =
        el(
          'button',
          'erm-btn erm-btn-secondary',
          'Show me alternatives'
        );


      altBtn.addEventListener(
        'click',
        function () {
          goToStep(11);
        }
      );


      left.appendChild(altBtn);
    }


    nav.appendChild(left);


    var fwdLabel;
    var fwdTarget;


    if (
      state.step >= 2 &&
      state.step <= 6
    ) {

      fwdLabel =
        'Continue';

      fwdTarget =
        state.step + 1;

    }

    else if (
      state.step === 7
    ) {

      fwdLabel =
        'Calculate My ERM Formula';

      fwdTarget =
        8;

    }

    else if (
      state.step === 9
    ) {

      fwdLabel =
        'See Your Recommended Mattress';

      fwdTarget =
        10;

    }

    else if (
      state.step === 10
    ) {

      fwdLabel =
        'View My Mattress Options';

      fwdTarget =
        13;

    }

    else if (
      state.step === 11
    ) {

      fwdLabel =
        'Continue';

      fwdTarget =
        12;

    }

    else if (
      state.step === 12
    ) {

      fwdLabel =
        'View My ERM Options';

      fwdTarget =
        13;

    }


    if (fwdLabel) {

      var ok =
        canAdvance();


      var fwdBtn =
        el(
          'button',

          'erm-btn erm-btn-primary' +
          (
            ok
              ? ''
              : ' erm-btn-disabled'
          ),

          fwdLabel
        );


      fwdBtn.disabled =
        !ok;


      fwdBtn.addEventListener(
        'click',
        function () {

          if (canAdvance()) {
            goToStep(fwdTarget);
          }
        }
      );


      nav.appendChild(fwdBtn);
    }


    container.appendChild(nav);
  }


  // ── INITIALISATION ───────────────────────────────────────────
  document.addEventListener(
    'DOMContentLoaded',
    function () {

      runSilentEngineTests();

      buildDOM();

      render();
    }
  );

})();

// END OF FILE — assets/erm-sleep-formula.js
